// extracted by mini-css-extract-plugin
module.exports = {"icon-up-arrow":"BottomArrow_icon-up-arrow__Hutiz","animate-bounce-down":"BottomArrow_animate-bounce-down__3E4hz","bounce-down":"BottomArrow_bounce-down__3Fr_p"};